import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/UserSupport.module.css';

interface UserSupportProps extends RouteComponentProps {
    // Define the props here
  }
  interface UserSupportState {
    // Define the state here
  }

  class UserSupport extends React.Component<UserSupportProps, UserSupportState>{
    constructor(props: UserSupportProps) {
      super(props);
  
      this.state = { }
  }

  goToPrivacyPolicy() {
    const {history} = this.props;
    history.push("/privacy");
}

    render(){
        return(
            <IonPage>
                <IonHeader class="ion-no-border">
                    <IonToolbar>
                    <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
                        <IonTitle>User Support</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent fullscreen >
                    <div className="whiteBG">
                        <div className={(styles.about)}>
                            <h1>Over ons</h1>
                            <p className={(styles.aboutText)}>UniPlay by WorkerPro Games &copy;</p>
                            <p className={(styles.aboutText)}>Contact: <a href="mailto:info@workerpro.be">info@workerpro.be</a></p>
                        </div>
                        <IonButton shape="round" size= "large" onClick={() => this.goToPrivacyPolicy()}>Privacy policy</IonButton> 
                    </div>
                </IonContent>
            </IonPage>
        );
    }
};

export default withRouter(UserSupport);
